import s from './ComponentFrame.scss'

const ComponentFrame = ({ title, subTitle = '', children }) => (
  <div className={s.compFrameWrapper}>
    <span className={s.compFrameTitle}>{title}</span>
    {subTitle && <span className={s.compFrameSubTitle}>{subTitle}</span>}
    <span className={s.verticalLine} />
    {children}
  </div>
)

export default ComponentFrame
